import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
// @mui
import MenuIcon from "@mui/icons-material/Menu";
import { ExpandLess, ExpandMore, FiberManualRecord } from "@mui/icons-material";
import { Box, Button, Collapse, Drawer, IconButton, List, ListItemButton, Stack, Typography } from "@mui/material";
//
import { getNavConfig } from "./navConfig";
import { NAVBAR_WIDTH } from "./constants";
import useResponsive from "../hooks/useResponsive";
import useAppContext from "src/hooks/useAppContext";
import UserMenu from "./UserMenu";

export function getActive(path, pathname) {
  return path ? pathname === path : false;
}

export default function Menu() {
  const [openMenu, setOpenMenu] = useState(false);

  const { user } = useAppContext();
  const { pathname } = useLocation();
  const isDesktop = useResponsive('up', 'lg');

  return (
    isDesktop ?
      <Drawer
        open
        variant="persistent"
      >
        <a href="/" style={{ margin: '16px auto 8px auto' }}>
          <img src="logo.jpg" width={80} height={80} alt='' />
        </a>

        <List
          sx={{ width: NAVBAR_WIDTH, height: '100vh', px: 1 }}
          component="nav"
        >
          {getNavConfig(user).map(e =>
            <Item key={e.label} item={e} setOpenMenu={setOpenMenu} />
          )}
        </List>
      </Drawer>
      :
      <>
        <Stack direction='row' justifyContent='space-between' sx={{ my: 0, p: 0.5 }}>
          <IconButton
            onClick={() => setOpenMenu(true)}
          >
            <MenuIcon sx={{ fontSize: 30, color: 'white' }} />
          </IconButton>

          {user ?
            <UserMenu />
            :
            (pathname !== '/auth' && pathname !== '/login' &&
              <Button
                size="small"
                variant="outlined"
                component={NavLink}
                to='/login'
              >
                Fazer login
              </Button>
            )
          }
        </Stack>

        <Drawer open={openMenu} anchor="left" onClose={() => setOpenMenu(false)} PaperProps={{ sx: { width: NAVBAR_WIDTH } }}>
          <img src="logo.jpg" width={80} height={80} alt='' style={{ margin: '8px auto' }} />

          <List
            sx={{ width: NAVBAR_WIDTH, height: '100vh', px: 1 }}
            component="nav"
          >
            {getNavConfig(user).map(e =>
              <Item key={e.label} item={e} setOpenMenu={setOpenMenu} />
            )}
          </List>
        </Drawer>
      </>
  );
}

function Item({ item, setOpenMenu }) {
  const [open, setOpen] = useState(false);

  const { path, icon, label, children } = item;

  const { pathname } = useLocation();

  const active = getActive(path, pathname);

  return (
    <>
      <ListItemButton
        {...active && { selected: true }}
        {...path && {
          component: NavLink,
          to: path
        }}
        onClick={() => {
          if (children)
            setOpen(prev => !prev);
          else setOpenMenu(prev => !prev)
        }}
        sx={{ borderRadius: 1, mb: 0.5 }}
      >
        <Stack direction='row' spacing={2} alignItems={'center'}>
          {icon ?? <FiberManualRecord sx={{ fontSize: 14 }} />}
          <Typography fontWeight={'bold'} variant="button">{label}</Typography>
          <Box sx={{ position: 'absolute', right: 8 }}>
            {children && (open ? <ExpandLess /> : <ExpandMore />)}
          </Box>
        </Stack>
      </ListItemButton>

      {children &&
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pl: 4 }}>
            {children.map(e =>
              <SubItem key={e.label} item={e} setOpenMenu={setOpenMenu} />
            )}
          </List>
        </Collapse>
      }
    </>
  )
}

function SubItem({ item, setOpenMenu }) {
  const [open, setOpen] = useState(false);

  const { path, icon, label, children } = item;

  const { pathname } = useLocation();

  const active = getActive(path, pathname);

  return (
    <>
      <ListItemButton
        {...active && { selected: true }}
        {...path && {
          component: NavLink,
          to: path
        }}
        onClick={() => {
          if (children)
            setOpen(prev => !prev);
          else setOpenMenu(prev => !prev)
        }}
        sx={{ borderRadius: 1, mb: 0.5 }}
      >
        <Stack direction='row' spacing={2} alignItems={'center'}>
          {icon ?? <FiberManualRecord sx={{ fontSize: 14 }} />}

          <Typography fontWeight={'bold'} variant="button">{label}</Typography>

          <Box sx={{ position: 'absolute', right: 8 }}>
            {children && (open ? <ExpandLess /> : <ExpandMore />)}
          </Box>
        </Stack>
      </ListItemButton>

      {children &&
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pl: 4 }}>
            {children.map(e =>
              <Item key={e.label} item={e} />
            )}
          </List>
        </Collapse>
      }
    </>
  )
}